<template>
  <div class="question-container" style="width:90%; padding-top: 20px;">
    <b-row style="padding-bottom: 5px">
      <b-col sm="4"> Survey Family</b-col>
      <b-col sm="8">
        <b-form-select v-model="surveyType" :options="surveyTypeList" v-on:change="selectSurveyType"
                       @selected="selectPage">
        </b-form-select>
      </b-col>
    </b-row>
    <b-row style="padding-bottom: 5px">
      <b-col sm="4"> Assigned Section</b-col>
      <b-col sm="8">
        <input type="hidden" name="sectionName" class="form-control" :value="section">

        <b-form-select v-model="selectedSection" :options="sections" v-on:change="selectSection"
                       @selected="selectPage" :disabled="isAssignedSectionEnabled">
        </b-form-select>
      </b-col>
    </b-row>
    <hr style="border-color: rgba(0, 0, 0, 0.1); margin: 20px;">
    <div>
      <b-card bg-variant="light">
        <div>
          <b-form-group label-cols="4" label-cols-lg="2" label-size="md" label="Page Name:" label-for="input-sm">
            <b-form-input id="input-sm" cols="8" size="sm" v-model="name" placeholder="Page Name"></b-form-input>
          </b-form-group>
        </div>

        <div>
          <b-form-group label-cols="4" label-cols-lg="2" label-size="md" label="Text:" label-for="input-sm">
            <b-form-textarea rows="4" id="input-sm" size="sm" v-model="verbiage"
                             placeholder="Page Verbiage"></b-form-textarea>
          </b-form-group>
        </div>
        <div>
          <b-form-group label-cols="4" label-cols-lg="2" label-size="md" label="Required Electives:"
                        label-for="input-sm">
            <b-form-input id="input-sm" size="sm" v-model="requiredElectives" placeholder="0" type="number">
            </b-form-input>
          </b-form-group>
        </div>
        <div v-if="showIfAnyQuestion">
          <div>
            <b-form-checkbox
                id="inputPage"
                v-model="isInputPage"
                name="inputPage"
                value="true"
                label="Input Page"
                unchecked-value="false"
            >Input Page
            </b-form-checkbox>
          </div>
        </div>
      </b-card>
      <hr style="border-color: rgba(0, 0, 0, 0.1); margin: 20px;">
    </div>
  </div>

  <!--  <div>-->
  <!--    <input type="submit" value="Submit" v-on:click="submit"/>-->
  <!--  </div>-->
</template>
<script>

import ListControl from "@/components/ListControl.vue";

export default {
  name: "CreatePage",
  components: {
    ListControl
  },
  data() {
    return {
      index: 1,
      controlType: null,
      controlTypeOptions: [
        {value: null, text: "Please Select A Question Type"},
        {value: "TEXT", text: "TEXT"},
        {value: "MATRIX", text: "MATRIX"},
        {value: "CHECKBOX", text: "CHECKBOX"}
      ],
      selectedValue: null,
      surveyType: null,
      colour: '',
      id: '',
      section: null,
      selectedSection: null,
      verbiage: '',
      name: '',
      type: null,
      requiredElectives: 0,
      isInputPage: false,
      isEnabled: false,
      creatorId: '',
      sections: [{value: null, text: 'Please select an Section'}],
      surveyTypeList: [{value: null, text: 'Select A Survey Type'},
        {
          value: "VINEYARD",
          text: 'VINEYARD'
        },
        {
          value: "WINE",
          text: 'WINE'
        }
      ]
    }
  },
  watch: {
    months: function (newVal) {
      this.showStep(newVal);
    }
  },
  beforeRouteEnter(to, from, next) {
    // TODO Find out whether Vineyard Admins should be able to add/edit questions?
    let roles = localStorage.getItem("roles");
    if (roles.includes("admin")) {
      next();
    } else {
      next({name: "My Account"})
    }
  },
  mounted() {
    let self = this;
    /*    this.$http.get(`vineyard/survey/pages/names?${self.measureFamily}`)
            .then(response => {
              console.log(response.data);
              let values = []
              Object.entries(response.data)
                  .map(item => values.push({value: item[0], text: item[1]}));
              self.pages = self.pages.concat(values);
            })*/
  },
  computed: {
    showTextQuestionProp: function () {
      return this.controlType === "TEXT";
    },
    showMatrixQuestionProp: function () {
      return false;// this.controlType === "MATRIX";
    },
    showMultipleQuestionProp: function () {
      return this.controlType === "CHECKBOX";
    },
    showIfAnyQuestion: function () {
      return this.selectedSection !== null;
    },
    isAssignedSectionEnabled: function () {
      return this.surveyType === null;
    },
    isControlTypeEnabled: function () {
      return this.selectedPage === null;
    },
    isCategoryEnabled: function () {
      return this.controlType === null;
    }
  },
  methods:
      {
        updateParent: function (value_from_child) {
          alert(value_from_child);
        },
        loadPages: function () {
          let self = this;
          this.pages = [{value: null, text: 'Please select an Page'}];
          this.$http.get(`vineyard/survey/pages/names?type=${self.measureFamily}`)
              .then(response => {
                console.log(response.data);
                let values = []
                Object.entries(response.data)
                    .map(item => values.push({value: item[0], text: item[1]}));
                values.sort((a, b) => {
                  if (a.text < b.text) {
                    return -1;
                  }
                  if (a.text > b.text) {
                    return 1;
                  }
                  return 0;
                })
                self.pages = self.pages.concat(values);
                console.log(self.pages);
              })
        },
        loadSurveySections: function () {
          let self = this;
          this.sections = [{value: null, text: 'Please select an Section'}];
          this.$http.get(`vineyard/survey/section/names?type=${self.surveyType}`)
              .then(response => {
                console.log(response.data);
                let values = []
                response.data
                    .map(item => values.push({value: item, text: item.replaceAll('_', ' ')}));
                values.sort((a, b) => {
                  if (a.text < b.text) {
                    return -1;
                  }
                  if (a.text > b.text) {
                    return 1;
                  }
                  return 0;
                })
                self.sections = self.sections.concat(values);
                console.log(self.sections);
              })
        },
        isValueSelected: function (value) {
          let isNotNull = value !== null;
          let isEqualTo1 = (isNotNull && value.value === 2) || (isNotNull && value === 2);
          return isNotNull && isEqualTo1;
        },
        submit: function () {
          let self = this;
          console.log(this.firstName, this.lastName);
          let question = this.toChecklistQuestion();
          this.$http.post(`vineyard/measure/${this.selectedPage}?type=${this.section}`, question)
              .then(response => {
                console.debug(response.data);
                this.$toasted.info("Question Created Successfully", {
                  containerClass: 'super-toasty',
                  iconPack: 'fontawesome',
                  closeOnSwipe: true,
                  action: {
                    text: 'DISMISS',
                    onClick: (e, toastObject) => {
                      toastObject.goAway(0);
                    }
                  },
                  icon: {
                    name: 'fa-check-circle',
                    after: false
                  }
                })
                    .goAway(5000);
                self.measureFamily = null;
                self.controlType = null;
                self.selectedPage = null;
                self.type = null;
                self.name = '';
                self.text = '';
                console.log("Resetting page for next question creation.")
              })

        },
        toChecklistQuestion: function () {
          return {
            controlType: this.controlType,
            section: this.selectedPage,
            name: this.name,
            verbiage: this.verbiage,
            requiredElective: this.requiredElective,
            inputPage: this.inputPage,
            pageAccentColor: this.pageAccentColor,
            pageBackgroundColor: this.pageBackgroundColor,
            type: this.type,
            columns: this.columns,
            qnum: 0,
            colCount: 1,
            choices: this.choices,
            greenNote: this.greenNote
          }
        },
        selectPage: function () {
          this.loadPages();
          this.name = this.pages.find(page => {
            return page.value === this.selectedPage
          }).text;
          console.debug("Label Value: " + this.name);
        },
        selectSection: function () {
          // this.loadPages();
          // this.name = this.pages.find(page => {
          //   return page.value === this.selectedPage
          // }).text;
          console.debug("Label Value: " + this.name);
        },
        selectQuestionFamily: function () {
          this.loadPages();
          console.debug("Loading Pages");
        },
        selectSurveyType: function () {
          this.loadSurveySections();
          console.debug("Loading Survey Sections");
        }
      }
}
</script>
<style>
div.question-container {
  padding-left: 50px;
}
</style>
